<template>
    <div>
      <div class="card steps-historique" id="historique">
        <header class="header-card has-text-white">
          {{ $t('detailContrat.avenants.historique') }}
        </header>
        <div class="card-content steps-container">
          <ul class="steps is-vertical has-content-centered" v-if="contrat.avenants.length > 0">
            <li v-for="(avenant, index) in contrat.avenants" :key="index"
                class="steps-segment" :class="{'is-active': index === 0}">
              <div class="steps-marker"></div>
              <div class="steps-content">
            <span class="has-text-link is-size-5 has-text-weight-bold">
                        {{ $t('detailContrat.avenants.titleModif', {
            user: getUser(avenant.creatorUser),
            }) }}
            </span>
                <span class="has-text-default is-size-7" >
            - {{ avenant.creationTime | formatDate }}
            </span>
                <div class="columns">
                  <div class="column is-narrow">
                    <p class="is-prewrap">{{ avenant.commentaire }}</p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div v-else>
            {{ $t('detailContrat.avenants.noHistorique') }}
          </div>
        </div>
      </div>
    </div>
</template>

<script>

import nomPrenomGetter from '@/services/general/nomPrenomGetter';

export default {
  name: 'BauxContratDetailAvenant',
  props: {
    contrat: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getUser(user) {
      if (user) return nomPrenomGetter(user);
      return 'Inconnu';
    },
  },
};
</script>

<style scoped>

</style>
